import { parseNullableValue } from '@clearverify/utils';

import { PeosSimpleListQuery, PeosSimpleListQueryVariables, usePeosSimpleListQuery } from 'src/api';

import { QueryParamsVariables, useAutocompleteFieldWithQuery } from '../forms';

export const usePeosAutocomplete = (
  paramVariables: QueryParamsVariables<PeosSimpleListQuery, PeosSimpleListQueryVariables> = {},
) => {
  return useAutocompleteFieldWithQuery(
    usePeosSimpleListQuery,
    {
      getQueryItems: data => data?.peoList,
      ...paramVariables,
    },
    {
      getOptionLabel: option => parseNullableValue(option.displayName),
    },
  );
};
